import { Component, OnInit, Output } from '@angular/core';
import { User } from 'app/shared/models/User';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { Router, Routes } from '@angular/router';

@Component({
	selector: 'navigation-bar',
	templateUrl: './navigation-bar.component.html'
})
export class NavigationbarComponent implements OnInit {
	searchTerm: string;
	user: User = new User;
	userUrl: Routes;

	constructor(
		private _authenticationService: AuthenticationService,
		private _router: Router
	) {
	}

	ngOnInit(): void {
	}

	navigateToAccount() {
		this._router.navigate(this.userUrl);
	}

	logOut(): void {
		this._authenticationService.logOut();
		this._router.navigate(['auth/login']);
	}

	search(): void {
		this._router.navigate(['/search', 'all', this.searchTerm]);
	}
}
